import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';

const { Search } = Input;

@inject("specialOfferStore")
@observer
class SearchMenuItemModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('In Room Dining'),
                dataIndex: 'taskName',
                key: 'taskName',
                width: '40%'
            },
            {
                title: t('Category'),
                dataIndex: 'categoryName',
                key: 'categoryName',
                width: '40%'
            },
            {
                title: t('Action'),
                dataIndex: 'taskId',
                key: 'action',
                width: '10%',
                render: taskId => (
                    <span>
                        <Button onClick={() => this.selectSearchMenuItemClicked(taskId)} type="primary">
                            {t('Select')}
                        </Button>
                    </span>
                ),
            },
        ]
    }

    searchChanged = e => {
        this.props.specialOfferStore.setItemSearchValue(e.target.value);
        this.props.specialOfferStore.searchItem();
    }

    selectSearchMenuItemClicked = taskId => {
        this.props.specialOfferStore.searchItemSelected(taskId);
        this.props.specialOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            lastChildItemFilter,
            itemSearchValue
        } = this.props.specialOfferStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder={t('Search In Room Dining')} value={itemSearchValue} onChange={this.searchChanged} />
                <Table columns={this.getColumns()} dataSource={lastChildItemFilter} />
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(SearchMenuItemModal)